import React, { forwardRef } from "react";
import classes from "./Contact.module.scss";

const Contact = forwardRef((_props, ref) => {
  return (
    <div className={classes.container}>
      <div className={classes.content} ref={ref}>
      <h1><span>LET'S WORK</span> <span className={classes.desc_2}>TOGETHER</span></h1>
        <p>
          Thanks for stopping by! You can reach me via any of the means below. I'll love to hear from you.
        </p>

        <p>
          <strong>Email</strong>
          <br />
          <a href="mailto:hello@toluls.com" target="_blank" rel="noreferrer noopener">hello@toluls.com</a>
        </p>
        <p>
          <strong>Linkedin</strong>
          <br />
          <a href="https://linkedin.com/in/tolulopeSaliu" target="_blank" rel="noreferrer noopener">Tolulope Saliu <span className={classes.linkOut}>{`>>`}</span></a>
        </p>
      </div>
    </div>
  );
});

export default Contact;
